jQuery(function($)
{
    var
        // Pseudo-Constants
        requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternSearch = '[search]',
        requestUriPattern
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/navigationHierarchyHtml/' + requestUriReplacePatternSearch,

        // module-global variables
        $body = $('body'),
        $container = $('#content'),
        idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    function getRequestUri(pageCategory, search)
    {
        return requestUriPattern
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternSearch, search);
    }

    function makeRequestPromise(pageCategory, search)
    {
        var
            requestUri = getRequestUri(pageCategory, search),
            requestId = idLastRequest + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequest += 1;

        return request;
    }

    function reload()
    {
        var
            pageCategory = orion.toPageCategory(),
            { search } = document.location,
            request = makeRequestPromise(pageCategory, search);

        function handleDone(markup)
        {
            if (idLastRequest !== request.requestId)
            {
                // stale request => discard
                return;
            }

            $('.js-filter__category-container').empty()
                .append(markup);
        }

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        request
            .done(handleDone)
            .fail(function()
            {
                // console.log("…category-navigation request failed");
            })
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    $container.on('category-navigation-reload', reload);
    $body.on([orion.constants.EventFiltersChanged, orion.constants.EventSortCriteriumChanged].join(' '), reload);
});
